import ImportContent from './ImportContent.jsx'
import { ImportProvider } from './ImportContext.jsx'

export const Import = (props) => {
    return (
        <ImportProvider {...props}>
            <ImportContent />
        </ImportProvider>
    )
}
